import ngTranslate from 'angular-translate';
import moment from 'moment';

import { StorageServiceModule } from 'services/storage/storage.service';

export const NotificationServiceModule = angular
    .module('app.services.utilities.notificationService', [
        ngTranslate,
        StorageServiceModule
    ]).factory('notificationService', (
        $window,
        $filter,
        $translate,
        storageService
    ) => {
        return {
            requestAuthorization: requestAuthorization,
            hideNotificationBanner: hideNotificationBanner,
            create: create,
            createOrderNotification: createOrderNotification
        };

        function requestAuthorization() {
            if ('Notification' in $window) {
                if ('localStorage' in $window && storageService.supported()) {
                    $window.localStorage.setItem('notificationSupport', true);
                }

                $window.Notification.requestPermission(authorizationCallback);
            } else {
                $window.localStorage.setItem('notificationSupport', false);
            }
        }

        function hideNotificationBanner() {
            if ('localStorage' in $window && storageService.supported()) {
                $window.localStorage.setItem('notificationsAuthorized', false);
                $window.localStorage.setItem('hideNotificationBanner', true);
            }

            if ('Notification' in $window && 'localStorage' in $window && storageService.supported()) {
                $window.localStorage.setItem('notificationSupport', true);
            }
        }

        function authorizationCallback(res) {
            if ('localStorage' in $window && storageService.supported()) {
                if (res === 'denied' || res === 'default') {
                    $window.localStorage.setItem('notificationsAuthorized', false);
                } else {
                    $window.localStorage.setItem('hideNotificationBanner', true);
                    $window.localStorage.setItem('notificationsAuthorized', true);
                }
            }
        }

        function create(title, body, icon, url) {
            if ('localStorage' in $window) {
                if ($window.localStorage.notificationSupport === false ||
                    $window.localStorage.notificationsAuthorized === 'false') {
                    return;
                }

                if ($window.localStorage.notificationsAuthorized === undefined) {
                    return;
                }
            }

            if ('Notification' in $window) {
                var notification = new $window.Notification(title, {
                    body: body,
                    icon: icon
                });

                notification.onclick = function() {
                    var orderWindow = $window.open(url, '_blank');
                    orderWindow.focus();
                };
            }
        }

        function createOrderNotification(order, store) {
            getOrderNotificationTitle(store).then((title) => {
                var body = `${$filter('currency')(order.grandTotal)} (${moment(order.createdOn).fromNow()})`;
                var icon;

                if (order.cart.items.length && order.cart.items[0].product.imageMetadata) {
                    icon = order.cart.items[0].product.imageMetadata.imageLink.fullUri;
                }

                var url = '/order/list?filter=New';
                create(title, body, icon, url);
            });
        }

        function getOrderNotificationTitle(store) {
            if (store === undefined) {
                return $translate('NOTIFICATION.NEWORDERNOSTORENAME');
            }
            return $translate('NOTIFICATION.NEWORDER', { STORE: store });
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/notification.service.js